<template>
  <!--srcviewscompanydetailsvuehtmlStart-->
  <!-- 公司详情 -->
  <div
    id="defaultId1"
    class="uIo8QCo"
    name="header"
    ref="scrollContainer"
    @scroll="handleScroll"
  >
    <content_view v-show="!Compare" id="gc95c2" ref="contentView">
      <template slot="header">
        <div id="cdd8de" class="uVNPU6Hss">
          <tools
            id="c46180"
            class="u35ff8"
            :UpdateStatus="UpdateStatus"
            :DownloadStatus="DownloadStatus"
            :config="toolsConfig"
            @clickMenu="clickMenu"
            ref="tools"
          >
          </tools>
        </div>
      </template>
      <template slot="details_view">
        <div
          id="g30b5a"
          :class="markList.length > 8 ? 'com_top ud2d4026' : 'ud2d40 com_top'"
        >
          <div id="ga36b2" class="c u4f5b">
            <div style="display: flex; align-items: center">
              <div id="g4fdd2" class="uc4421">
                <div class="uc4421_text">
                  {{ company == null ? "" : company?.base?.companyName }}
                </div>
              </div>
              <svg
                t="1728813835525"
                v-if="company?.base?.collectIds != '-'"
                class="icon icon24"
                viewBox="0 0 1075 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="12745"
              >
                <path
                  d="M273.757233 1023.872016a111.269069 111.269069 0 0 1-65.092533-21.142915 108.632604 108.632604 0 0 1-44.000812-107.378363l36.091416-208.459925c2.815642-16.074759-2.559675-32.379888-14.282986-43.591264l-0.102387-0.127984-152.863786-147.718839a108.58141 108.58141 0 0 1-28.054037-112.44652 109.835651 109.835651 0 0 1 89.358251-74.768104l211.249971-30.306551A49.836871 49.836871 0 0 0 343.610761 250.85019l94.477602-189.646315A110.168409 110.168409 0 0 1 537.454943 0.002048c42.413813 0 80.578567 23.421026 99.340984 61.227424l94.452005 189.646315c7.218283 14.48776 21.245302 24.624073 37.576027 27.055764l211.249972 30.434535a110.040425 110.040425 0 0 1 89.486235 74.742507 108.325443 108.325443 0 0 1-28.054037 112.472116l-152.863787 147.590856a49.504113 49.504113 0 0 0-14.385373 43.719248l36.091417 208.357538a108.607007 108.607007 0 0 1-44.128796 107.378363 110.731537 110.731537 0 0 1-116.541999 8.318944l-188.955203-98.445098a49.862467 49.862467 0 0 0-46.330116 0l-188.929606 98.445098a110.321989 110.321989 0 0 1-51.705433 12.926358z"
                  :fill="
                    company?.base?.collectIds == '-' ? '#006B9B' : '#FF6A6A'
                  "
                  p-id="12746"
                ></path>
              </svg>
            </div>
            <div id="gb2142" class="u7bd96">
              <div id="g77a65" class="u0e1f6">
                <img
                  id="gf2e43"
                  class="uc6a2b"
                  :src="company?.base?.img"
                  alt=""
                />
                <div id="g767ad" class="ubb08b">
                  <span> {{ company?.base?.city }}</span
                  ><span v-if="company?.base?.province"> , </span
                  ><span> {{ company?.base?.province }}</span
                  ><span v-if="company?.base?.country"> , </span
                  ><span> {{ company?.base?.country }}</span>
                </div>
              </div>
            </div>
            <el-tabs
              class="detail_header_info_label trade_top_tab_list"
              v-model="activeLabelTab"
            >
              <el-tab-pane
                :key="index"
                v-for="(item, index) in markList"
                :label="item.label"
                :name="item.label"
                :disabled="true"
              >
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="new-content-top-right">
            <div class="new-content-right-company">
              <div ref="companyRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CompanyDQI") }}
                <el-tooltip
                  class="item"
                  effect="light"
                  popper-class="detail-dqi-tips"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CompanyDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CompanyTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc2") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc3") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="new-content-right-country">
              <div ref="countryRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CountryDQI") }}
                <el-tooltip
                  class="item"
                  effect="light"
                  popper-class="detail-dqi-tips"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CountryDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CountryTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc2") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div id="g29da1" class="search_bottom_cont">
          <div id="g06fa7" class="ue896e">
            <ul id="ga9199" class="ufb44d">
              <div id="g251bf"></div>
              <li
                id="ga557d"
                @click="openUrl(item, '')"
                v-for="(item, index) in breadcrumbBar"
                :key="index"
                v-show="item.isShow"
                :class="tab1ActiveName == item.id ? 'bread_active' : ''"
                class="search_tab_item"
              >
                <div
                  class="textu99b63"
                  :class="tab1ActiveName == item.id ? 'bread_active2' : ''"
                >
                  {{ item.screenName }}
                </div>
              </li>
            </ul>
          </div>
          <div
            id="g599f6"
            v-show="isNoShowTab2 != 'noShowAll' && tab2_list.length > 0"
            class="u2ac23 mb10"
          >
            <div
              id="gc2939"
              @mouseleave="leaveTab2"
              v-show="isNoShowTab2 != 'showMark'"
              class="udea11"
            >
              <div id="g7e054" :style="tab2BkStyle" class="u518ac"></div>
              <div
                id="g608e1"
                @click="openUrl('', item)"
                @mouseenter="overTab2($event)"
                v-show="item.isShow"
                v-for="(item, index) in tab2_list"
                :key="index"
                :class="tab2ActiveName == item.id ? 'tab2_active' : ''"
                class="uebc34 font18"
              >
                {{ item.screenName }}
              </div>
            </div>
            <div
              id="gfff13"
              class="u8bb4e"
              v-if="markTotalList?.length > 0"
              :class="[isNoShowTab2 != 'showMark' ? 'mt20' : 'mt0']"
            >
              <div v-for="(item, index) in markTotalList" :key="index">
                <gui_mark_total
                  id="g9eda6"
                  class="u661e6"
                  :label="item.name"
                  :total="item.num"
                  v-if="item.num != '-'"
                >
                </gui_mark_total>
              </div>
            </div>
          </div>
          <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
            <button class="showBackToTop">
              <svg
                t="1732090638802"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6153"
                width="20"
                height="20"
              >
                <path
                  d="M564.4 213.7C549.9 199.2 530.9 192 512 192c-19 0-38 7.2-52.5 21.7L73.4 599.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l361.3-361V928c0 17.7 14.3 32 32 32s32-14.3 32-32V283.7l361.4 361c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L564.4 213.7zM96 129l832-1c17.7 0 32-14.4 32-32 0-17.7-14.3-32-32-32L96 65c-17.7 0-32 14.4-32 32 0 17.7 14.3 32 32 32z"
                  p-id="6154"
                  fill="#FFFFFF"
                ></path>
              </svg>
            </button>
          </div>

          <div id="g1e372" class="u0c804">
            <router-view
              :companyBaseRoute="company"
              id="cb02bf"
              @UpdatamarkTotalList="childUpdatamarkTotalList"
            >
            </router-view>
          </div>
        </div>
      </template>
    </content_view>
    <Suo
      :suoClose="Update"
      @closeCloseDialog="clossuoDialog($event)"
      @closeCloseDialog1="clossuoDialog1($event)"
      :ComapnyName="company?.base?.companyName"
    ></Suo>
    <div style="width: 100%" v-if="Compare">
      <compareCompanys
        :compareList="compareList"
        @CompareShowfalse="CompareShow($event)"
      ></compareCompanys>
    </div>
    <Reporterror
      :showReport="ReportError"
      :companynameen="companyName"
      :Company="company"
      @closeReportDialog="closeDialog($event)"
      :powerStatus="powerToReportErrorStatus"
    ></Reporterror>
    <detailExport
      :showDetailExportDialog="showDetailExportDialog"
      :companynameen="companyName"
      :Company="company"
      @update:showDetailExportDialog="closeDetailExportDialog"
    ></detailExport>
    <el-dialog
      :visible.sync="hasPrivilege"
      center
      :close-on-click-modal="true"
      @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower pw_div"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img
              class="powerdengpao buld_img"
              src="@/assets/images/powerdengpao.png"
              alt=""
            />
          </div>
          <div class="report_text" style="letter-spacing: normal">
            The feature you’re attempting to access is part of our premium
            membership benefits. To gain access to this feature and enjoy full
            access to premium features, please subscribe to our membership plan.
          </div>
        </div>
      </div>
      <div class="flex_center">
        <el-button
          class="btn_export btn_exportCCC"
          @click="hasPrivilege = false"
          >OK</el-button
        >
        <el-button
          class="btn_export"
          @click="
            $router.push({
              path: '/index/addCredit',
            })
          "
          >Subscribe</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="DownloadOnlineReport"
      center
      :close-on-click-modal="true"
      @close="DownloadOnlineReportDialog"
      custom-class="dialog_normalsuo dialog_normalpower dl_div"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img
              class="powerdengpao download_img"
              src="@/assets/images/DownloadOnlineSumit.png"
              alt=""
            />
          </div>
          <h3 class="margin-top20">Download Online Report</h3>
          <div class="report_text">
            The online report contains all the available data stored in our
            database on the subject, Downloading this report may trigger the
            system to update the data if the stored data is outdated or
            insufficient, lf an update is available, you'll receive a system
            notification within an hour for free updates.
          </div>
        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export" @click="DownloadOnlineSumit()"
          >Submit</el-button
        >
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import OperationWarning from "../../components/power/OperationWarning.vue";
import { mixins1 } from "@/mixins/index";
import content_view from "../layout/content_view.vue";
import gui_tabs from "../../components/gui_tabs/gui_tabs.vue";
import gui_tab_item from "../../components/gui_tabs/gui_tab_item.vue";
import gui_collapse from "../../components/gui_collapse/gui_collapse.vue";
import gui_checkbox from "../../components/gui_checkbox/gui_checkbox.vue";
import gui_scroll_x from "../../components/gui_scroll_x/gui_scroll_x.vue";
import gui_link_content from "../../components/gui_link_content/gui_link_content.vue";
import * as echarts from "echarts/core";
import { getCompanySnap } from "@/api/companyApi.js";
import gui_mark_total from "../../components/gui_mark_total/gui_mark_total.vue";
import tools from "@/views/layout/tools.vue";
import Suo from "./list/UpdateDialog.vue";
import Reporterror from "./list/detailreportError.vue";
// import detailExport from "../../components/detailExport/index.vue";
import detailExport from "../layout/detailExportDialog.vue";
import compareCompanys from "./list/detailecompareCompanys";
import ReLogin from "../../components/ReLogin.vue";
import { companyView } from "@/api/userApi";
//importEnd
import {
  downloadOnlinePdf,
  whetherDownLoadHK,
  saveDownLoadHK,
  whetherDeductPoints,
  getTabListOneLayer,
} from "@/api/userApi";
export default {
  name: "",
  mixins: [mixins1],
  props: {},
  watch: {
    $route(to, from) {
      // 在路由变化时执行的代码
      if (to.name == "businessActivitiesimport&Export") {
        this.tab2ActiveName = to.query.idpower;
      }
    },
  },

  mounted() {
    this.gettabList();
    this.setThemeColor();
    this.companyViewPower();
    this.handleResize();
    document.title = this.$route.query.companyName;
    window.addEventListener("resize", this.handleResize);
  },
  created() {
    this.getCompanySnaplist();
    window.addEventListener("scroll", this.handleScroll);
    this.whetherDeductPointsDetail();
  },
  beforeUnmount() {
    // 移除页面滚动事件的监听
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  active() {},

  components: {
    PermissionDialog,
    OperationWarning,
    Suo,
    Reporterror,
    compareCompanys,
    detailExport,
    tools,
    gui_mark_total,
    content_view,
    gui_tabs,
    gui_tab_item,
    gui_collapse,
    gui_checkbox,
    gui_scroll_x,
    gui_link_content,
    ReLogin,
  },

  data() {
    return {
      showBackToTop: false,
      reLoginVis: false,
      companyName: "",
      UpdateStatus: 0,
      DownloadStatus: 0,
      Compare: false,
      ReportError: false,
      showDetailExportDialog: false,
      powerToReportErrorStatus: false,
      powerExport: false,
      Update: false,
      Download: false,
      hasPrivilege: false,
      DownloadOnlineReport: false,
      randomKey: this.getRandomInt(1, 100), //
      // insertData
      // srcviewscompanydetailsvueDataStart

      // option2
      company: null,
      compareList: [],
      option2: {},
      // option1

      // isShowMenu
      isShowMenu: true,
      // cascader6Props
      cascader6Props: {
        expandTrigger: "click",
        multiple: true,
        checkStrictly: false,
        emitPath: true,
        lazy: false,
        lazyLoad: () => {},
        value: "value",
        label: "label",
        children: "children",
        disabled: "disabled",
        leaf: "leaf",
        hoverThreshold: 500,
      },
      // sort_listProps
      sort_listProps: {
        expandTrigger: "click",
        multiple: true,
        checkStrictly: false,
        emitPath: true,
        lazy: false,
        lazyLoad: () => {},
        value: "value",
        label: "label",
        children: "children",
        disabled: "disabled",
        leaf: "leaf",
        hoverThreshold: 500,
      },
      // toolsConfig
      toolsConfig: {
        menu: {
          isShow: true,
          isActive: false,
        },

        filter: {
          isShow: false,
          isActive: false,
        },

        select: {
          isShow: false,
          isActive: false,
        },

        edit: {
          isShow: false,
          isActive: false,
        },

        sort: {
          isShow: false,
          isActive: false,
        },

        collect: {
          isShow: false,
          isActive: false,
        },

        saved: {
          isShow: false,
          isActive: false,
        },

        compare: {
          isShow: true,
          isActive: true,
        },

        export: {
          isShow: true,
          isActive: true,
        },

        download: {
          isShow: true,
          isActive: false,
        },

        update: {
          isShow: true,
          isActive: false,
        },

        reportError: {
          isShow: true,
          isActive: true,
        },
        riskScanning: {
          isShow: false,
          isActive: false,
        },
        creditAssessment: {
          isShow: false,
          isActive: false,
        },
        dataAnalysis: {
          isShow: false,
          isActive: false,
        },
        customPortfolio: {
          isShow: false,
          isActive: false,
        },
        print: {
          isShow: false,
          isActive: false,
        },
        share: {
          isShow: true,
          isActive: true,
        },
      },
      star: false,
      isShowMoreMark: false,
      markList: [],
      activeLabelTab: "",
      breadcrumbBar: [],
      tab1ActiveName: this.$t("ContentTabs.BusinessActivities"),
      isNoShowTab2: false,
      hasPrivilege: false,
      // 背景样式
      tab2BkStyle: {
        width: "",
        height: "",
        left: "",
        top: "",
        display: "block",
      },
      tab2_list: ["Snapshot", "Profile", "Ownership"],
      tab2ActiveName: "Snapshot",
      markTotalList: [],
      lineHeight: 28,
      py: "55%",
      companyDQI: 0, //公司值
      countryDQI: 0, //国家值
      companyChart: null,
      countryChart: null,
      DownLoadHKActive: false,
    };
  },
  methods: {
    getwhetherDownLoadHK() {
      whetherDownLoadHK({
        companyAaaid: this.$route.query.id3a,
        countryCode: this.$route.query.companyCountry,
        companyName: this.companyName,
      }).then((res) => {
        if (res.data != 3) {
          if (res.data == 1) {
            this.toolsConfig.download.isActive = true;
          }
          this.DownloadStatus = res.data;
          this.DownLoadHKActive = true;
        } else {
          this.toolsConfig.download.isActive = true;
          this.DownloadStatus = res.data;
          this.DownLoadHKActive = false;
        }
      });
    },

    companyViewPower() {
      companyView({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (!res.data) {
          this.$store.dispatch("app/SetOperationWarning", true);
        }
      });
    },
    gotoSearchComapnyleads(value) {
      if (value.label && value.isClick) {
        this.$store.dispatch("app/SetlabelCode", "");
        this.$store.dispatch("app/SetlabelCodeName", "");
        this.$store.dispatch("app/SetarchagAin", true);
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + value.label + "/company",
          query: {
            searchname: value.label,
            companyCountry: this.countryCode,
            keword: this.Keyword ? 2 : 1,
            companyCountryEn: this.countryCode1,
            CompanyDetail: value.label,
          },
        });
      }
    },
    handleScroll() {
      // 判断页面滚动距离是否超过200px，更新showBackToTop的值
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      this.showBackToTop = scrollTop > 390;
    },
    scrollToTop() {
      const container = this.$refs.scrollContainer; // 使用 ref 获取容器
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    whetherDeductPointsDetail() {
      if (this.$route.query.id3a) {
        whetherDeductPoints({
          companyAaaid: this.$route.query.id3a,
        }).then((res) => {
          this.UpdateStatus = res.data.status;
          if (this.UpdateStatus == 6 || this.UpdateStatus == 2) {
            this.toolsConfig.update.isActive = true;
          }
        });
      }
    },
    gettabList() {
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleType: 4,
      }).then((res) => {
        let routerName = this.$route.name;

        if (res.code == 200) {
          this.breadcrumbBar = res.data;
          let moduleId =
            res.data.find((item) => routerName.includes(item.name))?.id || null;
          this.tab1ActiveName = moduleId;
          if (moduleId) {
            getTabListOneLayer({
              aaaId: this.$route.query.id3a,
              moduleId: moduleId,
            }).then((res) => {
              this.tab2_list = res.data;
              let tab2ActiveName =
                res.data.find((item) => routerName.includes(item.name))?.id ||
                null;
              this.tab2ActiveName = tab2ActiveName;
            });
          }
          let arr = [];
          res.data.map((item, index) => {
            if (item.name == "creditOpinion") {
              arr.push({
                id: item.name,
                name: item.screenName,
                children:
                  item.name == "creditOpinion"
                    ? [{ name: "tab2", id: "list" }]
                    : [
                        {
                          name: "tab2",
                          id: "list",
                          children: [
                            {
                              name: "Country",
                              id: "Country",
                              num: "US",
                            },
                            {
                              name: "Industry",
                              id: "Industry",
                              num: "Business Services",
                            },
                            {
                              name: "Size",
                              id: "Size",
                              num: "Miniature",
                            },
                            {
                              name: "Liquidity",
                              id: "Liquidity",
                              num: " Caution",
                            },
                            {
                              name: "Company Nature",
                              id: "Company Nature",
                              num: "Listed Companies",
                            },
                            {
                              name: "Number of Industry",
                              id: "Number of Industry",
                              num: "1,000 Companies",
                            },
                            {
                              name: "Industry Rating",
                              id: "Industry Rating",
                              num: "BBB-",
                            },
                            {
                              name: "Performance Comparison",
                              id: "Performance Comparison",
                              num: "Good",
                            },
                            {
                              name: "Attribute Comparison",
                              id: "Attribute Comparison",
                              num: "Good",
                            },
                            {
                              name: "Rating Comparison",
                              id: "Rating Comparison",
                              num: "Good",
                            },
                          ],
                        },
                      ],
                isShow: item.isShow,
                hasPrivilege: item.hasPrivilege,
                isNoShowTab2:
                  item.name == "creditOpinion" ? "noShowAll" : "showMark",
              });
            } else {
            }
          });
        }
      });
    },
    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    closeDetailExportDialog(visible) {
      this.showDetailExportDialog = visible;
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    DownloadOnlineReportDialog() {
      this.DownloadOnlineReport = false;
    },
    clossuoDialog(value) {
      this.Update = value;
    },
    clossuoDialog1(value) {
      // this.suopower = value;
    },
    CompareShow(val) {
      this.Compare = false;
      this.handleResize();
    },

    childUpdatamarkTotalList(value) {
      this.markTotalList = value;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },

    // insertMethod
    // srcviewscompanydetailsvueMethodStart
    // initTab
    getCompanySnaplist() {
      const id3a = this.$route.query.id3a;
      getCompanySnap({
        id3a: id3a,
      })
        .then((res) => {
          this.company = res.data;
          this.companyName = res.data.base.companyName;
          let countryImg = this.getCountryImgUrl(res.data.base.countryFlag);
          this.company.base.img = require("../../../static" + countryImg);
          localStorage.setItem("CompanyBase", JSON.stringify(res.data));
          this.companyDQI =
            res.data.base.companyDQI != "n.a." &&
            res.data.base.companyDQI != "-"
              ? parseInt(res.data.base.companyDQI)
              : 0;
          this.initCompanyEchart();
          this.countryDQI =
            res.data.base.countryDQI && res.data.base.countryDQI != "-"
              ? parseInt(res.data.base.countryDQI)
              : 0;
          this.initCountryEchart();
          this.markList = res.data.labels;
          // tab 左右切换按钮状态 修复 通过监听 tab滑动style变化来触发状态更新***********
          this.$nextTick(() => {
            const nav = this.$el.querySelector(".el-tabs__nav");
            if (!nav) return;
            let syncing = false;
            this.observer = new MutationObserver(() => {
              if (syncing) return;
              syncing = true;
              const cur = this.activeLabelTab;
              this.activeLabelTab = "__temp__";
              this.$nextTick(() => {
                this.activeLabelTab = cur;
                syncing = false;
              });
            });
            this.observer.observe(nav, {
              attributes: true,
              attributeFilter: ["style"],
            });
          });
          // ***********************************************************************
          this.getwhetherDownLoadHK();
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    initTab() {
      let routes = {};
      this.breadcrumbBar.forEach((item) => {
        item.children.forEach((item2) => {
          let obj = {
            tab1: item.id,
            tab2: item2.id,
            isNoShowTab2: item.isNoShowTab2,
            tab2List: item.children,
          };
          routes[item.id + item2.id] = obj;
        });
      });

      let routerName = this.$route.name;

      this.tab1ActiveName = routes[routerName].tab1;
      this.tab2ActiveName = routes[routerName].tab2;
      this.tab2_list = routes[routerName].tab2List;

      let markTotal = this.tab2_list.find(
        (item) => item.id == this.tab2ActiveName,
      );

      let isNoShowTab2 = routes[routerName].isNoShowTab2;

      if (isNoShowTab2) {
        this.isNoShowTab2 = isNoShowTab2;
      } else {
        this.isNoShowTab2 = false;
      }
    },
    // 公司echarts
    initCompanyEchart() {
      this.companyChart = echarts.init(this.$refs.companyRef);
      let data = this.companyDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.companyChart.setOption(option);
    },
    // 国家echarts
    initCountryEchart() {
      this.countryChart = echarts.init(this.$refs.countryRef);
      let data = this.countryDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.countryChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.companyChart) {
        this.companyChart.resize();
      }
      if (this.countryChart) {
        this.countryChart.resize();
      }
    },
    handleResize() {
      if (window.innerWidth > 1920) {
        // 大屏幕
        this.radiusX1 = 48;
        this.radiusX2 = 62;
        this.fontSize = 26;
        this.lineHeight = 28;
        this.py = "55%";
      } else {
        this.radiusX1 = 32;
        this.radiusX2 = 41;
        this.fontSize = 16;
        this.lineHeight = 18;
        this.py = "52%";
      }
      this.initCompanyEchart();
      this.initCountryEchart();
      this.resizeChart();
    },
    // clickMenu 控制详情工具栏
    clickMenu(name, data) {
      switch (name) {
        case "menu":
          this.$refs.contentView.isMenu = !this.$refs.contentView.isMenu;
          break;
        case "select":
          this.$nextTick(() => {
            if (this.$refs.route.isOpenSlct) {
              this.$refs.route.isOpenSlct = false;
              this.$refs.route.isOpenSlct = false;
            } else {
              this.$refs.route.isOpenSlct = "Select";
              this.$refs.route.isOpenSlct = "Select";
            }
          });
          break;
        case "Update":
          this.Update = true;

          break;
        case "download":
          if (this.DownLoadHKActive) {
            downloadOnlinePdf(this.$route.query.id3a)
              .then((res) => {
                const binaryData = [];
                binaryData.push(res);
                let pdfUrl = window.URL.createObjectURL(
                  new Blob(binaryData, { type: "application/pdf" }),
                );
                window.open(pdfUrl, "_blank");
              })
              .catch((err) => {
                this.reLoginVis = String(err).includes("403");
              });
          } else {
            this.DownloadOnlineReport = true;
          }

          break;
        case "Compare":
          this.Compare = true;
          break;

        case "Report":
          this.ReportError = true;
          this.powerToReportErrorStatus = true;
          break;
        case "Export":
          this.showDetailExportDialog = true;
          this.powerExport = true;
          break;

        case "edit":
          break;
        case "Share":
          let DetailCompanylist = [{ aaa_id: this.$route.query.id3a }];
          this.$store.dispatch("app/setchangeList", DetailCompanylist);
          break;
      }
    },
    DownloadOnlineSumit() {
      saveDownLoadHK({
        companyAaaid: this.$route.query.id3a,
        countryCode: this.$route.query.companyCountry,
        companyName: this.companyName,
      }).then((res) => {
        this.DownloadOnlineReport = false;
      });
    },
    // toggleMoreMark
    toggleMoreMark() {
      this.isShowMoreMark = !this.isShowMoreMark;
    }, // openUrl
    openUrl(tab1Name, tab2Name) {
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let SACode1 = "";
      newscountry.map((item) => {
        if (item.countryCode == this.company.base.countryFlag) {
          SACode1 = item.dowjonesCountrycode;
        }
      });

      if (tab1Name?.hasPrivilege || tab2Name?.hasPrivilege) {
        if (!tab1Name) {
          let tab1NameVal = this.breadcrumbBar.find(
            (item) => item.id == this.tab1ActiveName,
          )?.name;
          let tab2NameVal = tab2Name.name;
          this.tab2ActiveName = tab2Name.id;
          this.$router.push({
            name: tab1NameVal + tab2NameVal,
            params: {
              id: this.$route.params.id,
              idpower: tab2Name?.id,
            },
            query: {
              id3a: this.$route.query.id3a,
              companyCountry: this.company.base.countryFlag,
              SACode1: SACode1,
              idpower: tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
              companyName: this.$route.query.companyName,
              keword: this.$route.query.keword,
            },
          });
        } else {
          this.tab1ActiveName = tab1Name?.id;
          getTabListOneLayer({
            aaaId: this.$route.query.id3a,
            moduleId: tab1Name?.id,
          }).then((res) => {
            if (res.data.length > 0) {
              this.tab2_list = res.data.filter((item) => item.isShow == true);
              if (this.tab2_list.length > 0) {
                this.isNoShowTab2 = "";
                this.tab2ActiveName = this.tab2_list[0]?.id;
                this.$router.push({
                  name: tab1Name.name + this.tab2_list[0]?.name,
                  params: {
                    id: this.$route.params.id,
                    idpower: tab2Name?.id,
                  },
                  query: {
                    id3a: this.$route.query.id3a,
                    companyCountry: this.company.base.countryFlag,
                    SACode1: SACode1,
                    idpower:
                      tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                    companyName: this.$route.query.companyName,
                    keword: this.$route.query.keword,
                  },
                });
              }
            } else {
              if (
                tab1Name?.name == "creditOpinion" ||
                tab1Name?.name == "marketAnalysis"
              ) {
                if (tab1Name?.name == "creditOpinion") {
                  this.isNoShowTab2 = "noShowAll";
                } else if (tab1Name?.name == "marketAnalysis") {
                  this.isNoShowTab2 = "showMark";
                }
                this.tab2_list =
                  tab1Name?.name == "creditOpinion"
                    ? [{ name: "tab2", id: "list" }]
                    : [
                        {
                          name: "tab2",
                          id: "list",
                          children: [
                            {
                              name: "Country",
                              id: "Country",
                              num: "US",
                            },
                            {
                              name: "Industry",
                              id: "Industry",
                              num: "Business Services",
                            },
                            {
                              name: "Size",
                              id: "Size",
                              num: "Miniature",
                            },
                            {
                              name: "Liquidity",
                              id: "Liquidity",
                              num: " Caution",
                            },
                            {
                              name: "Company Nature",
                              id: "Company Nature",
                              num: "Listed Companies",
                            },
                            {
                              name: "Number of Industry",
                              id: "Number of Industry",
                              num: "1,000 Companies",
                            },
                            {
                              name: "Industry Rating",
                              id: "Industry Rating",
                              num: "BBB-",
                            },
                            {
                              name: "Performance Comparison",
                              id: "Performance Comparison",
                              num: "Good",
                            },
                            {
                              name: "Attribute Comparison",
                              id: "Attribute Comparison",
                              num: "Good",
                            },
                            {
                              name: "Rating Comparison",
                              id: "Rating Comparison",
                              num: "Good",
                            },
                          ],
                        },
                      ];
                this.$router.push({
                  name: tab1Name.name + this.tab2_list[0].id,
                  params: {
                    id: this.$route.params.id,
                    idpower: tab2Name?.id,
                  },
                  query: {
                    id3a: this.$route.query.id3a,
                    companyCountry: this.$route.query.companyCountry,

                    SACode1: SACode1,
                    idpower:
                      tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                    companyName: this.$route.query.companyName,
                    keword: this.$route.query.keword,
                  },
                });
              }
            }
          });
        }
      } else {
        this.hasPrivilege = true;
      }
    }, // 离开悬浮
    leaveTab2(event) {
      this.tab2BkStyle.display = `none`;
    }, // 悬浮tab2监听
    overTab2(e) {
      let event = e;
      const rect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentNode.getBoundingClientRect();
      this.tab2BkStyle.width = `${rect.width}px`;
      this.tab2BkStyle.height = `${rect.height}px`;
      this.tab2BkStyle.left = `${rect.left - parentRect.left}px`;
      this.tab2BkStyle.top = `${rect.top - parentRect.top}px`;
      this.tab2BkStyle.display = `block`;
    }, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#1290C9");
      this.$store.dispatch("app/setSearchType", "company");
    },
    // srcviewscompanydetailsvueMethodEnd
  },
  computed: {},
  beforeDestroy() {
    // 页面销毁时 解除监听tab切换*************************************************
    this.observer && this.observer.disconnect();
    // *************************************************************************
  },
};
</script>
<style>
.uIo8QCo {
  display: flex;
  justify-content: center;
  overflow-y: hidden;
  overflow-x: hidden;
}

.uVNPU6H {
  width: 100%;
}

.u35ff8 {
  width: 100%;
  overflow: hidden;
}

.com_top {
  display: flex;
  height: 286px;
  width: 100%;
  padding-top: 20px;
  padding-left: 70px;
  padding-right: 70px;
  padding-bottom: 146px;
  justify-content: space-between;
  gap: 30px;
  background-color: #1290c9;
}

.u4f5b {
  display: block;
  justify-content: flex-start;
  align-items: flex-start;
  border-color: rgb(172, 201, 24);
  color: rgb(255, 255, 255);
}

.uc4421 {
  color: rgb(255, 255, 255);
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  padding-top: 0rem;
  padding-left: 0rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uc4421_text {
  font-size: 36px;
  line-height: 40px;
  font-family: "Arial Bold";
  overflow: hidden;
  text-overflow: ellipsis;
}

.u0e1f6 {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.uc6a2b {
  width: 36px;
  height: 22px;
  margin-right: 10px;
}

.ubb08b {
  color: rgb(255, 255, 255);
  font-size: 18px;
  height: auto;
  overflow-y: auto;
  min-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u5b01d {
  color: rgb(255, 255, 255);
  margin-top: 20px;
  font-size: 18px;
}

.u83191 {
  display: flex;
  flex: auto;
}

.uboa8Fv {
  display: flex;
}

.u07ca9 {
  display: inline-block;
  margin-left: -1.4rem;
  margin-right: 1.4285714285714286rem;
  box-sizing: content-box;
}

.u61637 {
  border-color: rgb(53, 24, 201);
  overflow-y: auto;
}

.u91cf9 {
  display: inline-block;
  border: 1px solid rgb(255, 255, 255);
  padding: 8px 12px;
  color: rgb(255, 255, 255);
  margin-right: 6px;
  margin-bottom: 6px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.NotPoer {
  cursor: no-drop !important;
}

.u9KBSet {
  transform: rotate(1deg);
}

.u6f31f {
  display: flex;
  width: 332px;
  height: 120px;
  position: relative;
  justify-content: end;
}

.u1c1b4 {
  width: 50%;
  height: 200px;
}

.u0304c {
  width: 50%;
  height: 200px;
}

.search_bottom_cont {
  margin-top: -127px;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  z-index: 99;
}

.ue896e {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -3px;
}

.ufb44d {
  display: flex;
  flex-direction: row;
  text-align: center;
}

.search_tab_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  color: rgb(255, 255, 255);
  margin-right: 14px;
  line-height: 22px;
  padding: 14px 20px 10px;
  background-color: rgba(255, 255, 255, 0.2);
  text-align: center;
  border-radius: 5px 5px 0px 0px;
  box-sizing: border-box;
  cursor: pointer;
}

.textu99b63 {
  font-size: 18px;
}

.u99b63:last-child {
  margin-right: 0;
}

.bread_active {
  background-color: rgb(255, 255, 255);
}

.bread_active2 {
  font-family: "Arial Bold" !important;
  color: #1290c9;
}

.u2ac23 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  padding: 30px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.udea11 {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 5px 20px;
  position: relative;
  border-radius: 5px;
  gap: 20px;
}

.u518ac {
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: 0.4s;
  z-index: 0;
  pointer-events: none;
}

.uebc34 {
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 5;
}

.uebc34:last-child {
  margin-right: 0;
}

.tab2_active {
  background-color: rgb(255, 255, 255);
  z-index: 10;
  font-weight: 400;
  font-family: "Arial Bold";
}

.u8bb4e {
  display: flex;
}

.u661e6 {
  margin-right: 5px;
  margin-left: 5px;
  height: 100%;
}

.u0c804 {
  border-radius: 5px;
}

.uboa8Fv .submore {
  height: 6rem;
  overflow-y: auto;
  margin-right: 30px;
}

.submore::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}

.u91cf9:nth-child(5n + 5) {
  color: #ffffff;
  border: 1px solid #ffb02b;
}

.u91cf9:nth-child(5n + 4) {
  color: #ffffff;
  border: 1px solid #00f1ff;
}

.u91cf9:nth-child(5n + 3) {
  color: #ffffff;
  border: 1px solid #5aff4a;
}

.u91cf9:nth-child(5n + 2) {
  color: #ffffff;
  border: 1px solid #ff8ecb;
}

.u0a580 .subsvg {
  transform: rotate(180deg);
}

.back-to-top {
  z-index: 99999;
  position: fixed;
  transition: opacity 0.4s ease-in-out 0s;
  opacity: 1;
  box-sizing: border-box;
  bottom: 150px;
  right: 25px;
  cursor: pointer;
}

.showBackToTop {
  width: 40px;
  height: 40px;
  background: #1290c9;
  border-radius: 50%;
  box-shadow: 0 2px 10px 0px rgba(0, 122, 177, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.u4f5b {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
  overflow: hidden;
  border-color: rgb(172, 201, 24);
  color: rgb(255, 255, 255);
}

.detail_header_info_label.trade_top_tab_list .el-icon-arrow-left,
.detail_header_info_label.trade_top_tab_list .el-tabs__nav-next {
  color: #1290c9;
}

.detail-dqi-tips {
  width: 540px;
  height: auto;
  padding: 20px !important;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.html-new-page .el-tooltip__popper.detail-dqi-tips {
  transform: translateY(-2px);
}

.detail-dqi-tips .detail-dqi-tips-header {
  margin-bottom: 20px;
  line-height: 26px;
  font-family: "Arial Bold";
  font-size: 24px;
  color: #1a2332;
}

.detail-dqi-tips .detail-dqi-tips-desc {
  margin-bottom: 14px;
  line-height: 26px;
  font-size: 18px;
  color: #29445d;
}

.detail-dqi-tips .detail-dqi-tips-sub-desc {
  line-height: 22px;
}

.new-content-top-right {
  min-width: 326px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.new-content-right-company,
.new-content-right-country {
  width: 124px;
  height: auto;
}

.new-content-right-echart {
  width: 100%;
  height: 62px;
  margin-bottom: 8px;
}

.new-content-right-title {
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
}

.new-content-right-title i {
  margin-left: 6px;
  font-size: 20px;
  color: #ffdb01;
  cursor: pointer;
}

.uVNPU6Hss {
  display: flex;
  align-items: center;
  width: 100%;
  height: 4em;
  margin-right: 0em;
  padding-right: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  margin-bottom: 0em;
  margin-top: 0em;
  margin-left: 0em;
}

.detail_cont h3 {
  width: auto;
  height: 28px;
  font-family: "Arial Bold";
  font-size: 26px;
  color: #1a2332;
  text-align: center;
  line-height: 28px;
}

.report_text {
  margin: 0 !important;
  padding: 20px 0 !important;
  letter-spacing: 0.4px;
  font-size: 20px !important;
  line-height: 30px !important;
  text-align: justify;
  color: #1a2332;
}

.buld_img {
  width: 90px;
  height: 80px;
}

.download_img {
  width: 60px;
  height: 60px;
}

.dl_div {
  width: 536px !important;
}

.dl_div .btn_export {
  width: 210px;
  height: 60px;
  font-size: 20px;
  line-height: 26px;
}

.pw_div {
  width: 550px !important;
  height: auto !important;
}

.pw_div .btn_export,
.pw_div .el-button {
  width: 210px;
  height: 60px;
  min-width: auto !important;
  font-size: 20px;
  line-height: 24px;
}
.icon24 {
  width: 24px;
  height: 24px;
  margin-left: 40px;
}

@media (max-width: 1920px) {
  .com_top {
    height: 230px;
    padding-top: 15px;
    padding-left: 52px;
    padding-right: 52px;
    padding-bottom: 100px;
    gap: 24px;
  }

  .u4f5b {
    gap: 12px;
  }

  .u2ac23 {
    padding: 15px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .new-content-top-right {
    margin-top: 7px;
    min-width: 218px;
  }

  .search_tab_item {
    margin-right: 10px;
    line-height: 18px;
    padding: 10px 15px 7px;
  }

  .uc4421_text {
    font-size: 28px;
    line-height: 30px;
  }

  .u0e1f6 {
    margin-top: 7px;
    margin-bottom: 7px;
  }

  .uc6a2b {
    width: 32px;
    height: 20px;
  }

  .search_bottom_cont {
    margin-top: -80px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .uebc34 {
    padding: 7px 15px;
  }

  .ubb08b,
  .u5b01d,
  .textu99b63 {
    font-size: 16px;
  }

  .udea11 {
    padding: 4px 15px;
    gap: 15px;
  }

  .detail_cont h3 {
    height: 22px;
    font-size: 20px;
    line-height: 22px;
  }

  .report_text {
    padding: 15px 0 !important;
    font-size: 16px !important;
    line-height: 22px !important;
  }

  .dialog_normalpower {
    width: 420px !important;
    height: 340px;
  }

  .new-content-right-company,
  .new-content-right-country {
    width: 82px;
  }
  .new-content-right-echart {
    height: 42px;
    margin-bottom: 6px;
  }
  .new-content-right-title {
    line-height: 14px;
    font-size: 12px;
  }

  .new-content-right-title i {
    margin-left: 4px;
    font-size: 14px;
  }

  .new-content-detail-wrap {
    top: 168px;
    padding: 0 14px;
  }

  .buld_img {
    width: 68px;
    height: 60px;
  }

  .download_img {
    width: 45px;
    height: 45px;
  }

  .dl_div {
    width: 430px !important;
  }

  .dl_div .btn_export {
    width: 158px;
    height: 46px;
    font-size: 16px;
    line-height: 20px;
  }

  .pw_div {
    width: 444px !important;
  }

  .pw_div .btn_export,
  .pw_div .el-button {
    width: 158px;
    height: 46px;
    font-size: 16px;
    line-height: 18px;
  }
  .detail-dqi-tips {
    width: 360px;
    padding: 14px !important;
    border-radius: 3px;
  }

  .html-new-page .el-tooltip__popper.detail-dqi-tips {
    transform: translateY(-2px);
  }

  .detail-dqi-tips .detail-dqi-tips-header {
    margin-bottom: 14px;
    line-height: 24px;
    font-size: 20px;
  }

  .detail-dqi-tips .detail-dqi-tips-desc {
    margin-bottom: 8px;
    line-height: 20px;
    font-size: 16px;
  }

  .detail-dqi-tips .detail-dqi-tips-sub-desc {
    line-height: 16px;
  }
  .icon24 {
    width: 18px;
    height: 18px;
    margin-left: 30px;
  }
}

@media (max-width: 1439px) {
  .com_top {
    min-height: 180px;
    padding-top: 12px;
    padding-left: 46px;
    padding-right: 46px;
  }

  .u2ac23 {
    padding: 12px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .search_tab_item {
    margin-right: 10px;
    line-height: 16px;
    padding: 9px 13px 6px;
  }

  .uc4421_text {
    font-size: 28px;
  }

  .u0e1f6 {
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .uc6a2b {
    width: 28px;
    height: 18px;
  }

  .search_bottom_cont {
    margin-top: -70px;
    margin-left: 13px;
    margin-right: 13px;
  }

  .uebc34 {
    padding: 7px 15px;
  }

  .ubb08b,
  .u5b01d,
  .textu99b63 {
    font-size: 14px;
  }

  .udea11 {
    padding: 3px 12px;
    gap: 12px;
  }

  .detail_cont h3 {
    height: 20px;
    font-size: 18px;
    line-height: 20px;
  }

  .report_text {
    padding: 12px 0 !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }

  .dialog_normalpower {
    width: 380px !important;
    height: 300px;
  }

  .buld_img {
    width: 60px;
    height: 54px;
  }

  .download_img {
    width: 40px;
    height: 40px;
  }

  .dl_div {
    width: 380px !important;
  }

  .dl_div .btn_export {
    width: 140px;
    height: 40px;
    font-size: 14px;
    line-height: 18px;
  }

  .pw_div {
    width: 372px !important;
  }

  .pw_div .btn_export,
  .pw_div .el-button {
    width: 140px;
    height: 40px;
    font-size: 14px;
    line-height: 16px;
  }
  .icon24 {
    width: 16px;
    height: 16px;
    margin-left: 26px;
  }
}
</style>
